module.exports = __webpack_public_path__ + "img/bg_newsletter_form_embedded_v2.91dbdb1.jpg";